<template>
  <div
    class="el-tree"
    :class="{ 'el-tree--highlight-current': highlightCurrent }"
    role="tree"
  >
    <el-input v-show="showFliter" :placeholder="$t('components.tree.placeholder')" v-model="filterText"></el-input>
      <tree-node
        v-for="(child, idx) in dataTree"
        :node="child"
        :props="props"
        :indent="indent"
        :render-content="renderContent"
        :current-node="currentNode"
        :show-checkbox="showCheckbox"
        :default-expand-all="defaultExpandAll"
        :level="level+1"
        :valueMap="valueMap"
        :for-bidden="for_bidden"
        :expand-checked="showCheckbox?expandChecked:child.children&&child.children.length>0&&model[0]&&child.children.filter(v=>v.id==model[0].id).length>0"
        :key="idx"
        @check-change="checkChange"
        @current-change="currentChange">
      </tree-node>
      <div class="el-tree__empty-block" v-if="!data || data.length === 0">
        <span class="el-tree__empty-text">{{ emptyText }}</span>
      </div>
  </div>
</template>

<script>
  import TreeNode from './tree-node.vue';
  import {buildTree} from "@/server/utils.js"

  export default {
    name: 'Tree',
    components: {
      TreeNode
    },

    data() {
      return {
        store: null,
        root: null,
        currentNode: null,
        level:0,
        filterText:'',
        treeItems: null,
        checkboxItems: [],
        model:this.value,
        valueMap:{},
        dataTree:[],
        for_bidden:{},
      };
    },

    props: {
      data: {
        type: Array
      },
      value:{
        type:Array
      },
      emptyText: {
        type: String,
        default() {
          return '暂无数据';
        }
      },
      nodeKey: String,
      checkStrictly: Boolean,
      defaultExpandAll: Boolean,
      expandOnClickNode: {
        type: Boolean,
        default: true
      },
      checkDescendants: {
        type: Boolean,
        default: false
      },
      autoExpandParent: {
        type: Boolean,
        default: true
      },
      defaultCheckedKeys: Array,
      defaultExpandedKeys: Array,
      renderContent: Function,
      showCheckbox: {
        type: Boolean,
        default: true
      },
      expandChecked: {
        type: Boolean,
        default: false
      },
      showFliter: {
        type: Boolean,
        default: false
      },
      props: {
        default() {
          return {
            children: 'children',
            label: 'label',
            icon: 'icon',
            disabled: 'disabled'
          };
        }
      },
      lazy: {
        type: Boolean,
        default: false
      },
      highlightCurrent: Boolean,
      load: Function,
      filterNodeMethod: Function,
      accordion: Boolean,
      indent: {
        type: Number,
        default: 18
      },
      forBidden: {
        type: Object,
        default: function(){
          return {}
        }
      },
    },

    computed: {
      valueNotInData: function () {
        var dataMap = {};
        var result = [];
        this.data.map(v=>{dataMap[v.id]=true});
        this.value.map(v=>{
          if(!dataMap[v.id]) {
            result.push(v);
          }
        })
        return result;
      }
    },

    watch: {
      data:function (val) {
        this.dataTree = buildTree(val,this.valueMap,this.forBidden.dataid? this.forBidden.dataid:(this.forBidden.flag?this.forBidden.flag:false));
        this.checkChange();
      },
      value:function (val) {
        if(val) {
          var valueMap = {};
          val.map(v => valueMap[v.id] = true);
          this.valueMap = valueMap;
          this.dataTree = buildTree(this.data,this.valueMap,this.forBidden.dataid? this.forBidden.dataid:(this.forBidden.flag?this.forBidden.flag:false));
          this.checkChange();
          this.model = val
          this.showCheckbox?null:this.currentNode=val[0]
        }
      },
      model:function (val) {
        this.$emit('input',val)
      },
      filterText:function (val) {
        this.dataTree.map(v=>{
          this.filter(v,val);
        });
      },
      forBidden:function(val){
        this.for_bidden = val;
      }
    },

    methods: {
      filter(node,text) {
        node.children.map(v=>{
          this.filter(v,text);
        });
        if(node.label && node.label.indexOf(text) != -1) {
          node.visible = true;
        } else if(node.children && node.children.filter(v=>v.visible==true).length>0) {
          node.visible = true;
        } else {
          node.visible = false;
        }
      },
      currentChange(node) {
        this.currentNode = node;
        if(!this.showCheckbox){
          this.$emit('input',[node])
        }
      },
      checkChange(node) {
        var all = []
        function concatall(data){
          data.forEach(v=>{
              if(v.checked){
                all.push(Object.assign({}, v.data));
              } else {
                if (v.children) {
                  concatall(v.children)
                }
              }
          })
        }
        concatall(this.dataTree)
        this.model = all.concat(this.valueNotInData);
      }
    },

    created() {
    },
    mounted() {
    },
    updated() {
    }
  };
</script>
